import { StepProps } from 'src/UI/drawer-flow/DrawerFlow';
import { ReportData } from '../SuitabilityFlow';
import { SettingsRow } from 'src/suitability-report/SettingsRow';
import React from 'react';
import SelectSuitabilityReportTemplateStep from 'src/UI/drawer-flow/SelectSuitabilityReportTemplateStep';

export default function SuitabilitySelectTemplateStep(props: StepProps<ReportData>) {
  const { data, setData } = props;

  const handleToggle = (key: string, value: boolean) => {
    setData({ ...data, [key]: value });
  };

  return (
    <SelectSuitabilityReportTemplateStep
      {...props}
      type="SUITABILITY_REPORT"
      renderExpandedContent={() => (
        <>
          <SettingsRow
            titleColor={'gray.8'}
            title="Add title page"
            checked={props.data.addTitlePage}
            onChange={value => handleToggle('addTitlePage', value)}
            titleSize={'sm'}
            showDivider
          />
          <SettingsRow
            titleColor={'gray.8'}
            title="Add table of contents"
            checked={props.data.addTableOfContents}
            onChange={value => handleToggle('addTableOfContents', value)}
            titleSize={'sm'}
          />
        </>
      )}
    />
  );
}
